"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolComp = exports.AvatarComp = exports.BaseAvatar = exports.Gravatar = void 0;
const react_1 = __importStar(require("react"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const classnames_1 = __importDefault(require("classnames"));
const get_1 = __importDefault(require("lodash/get"));
const prop_types_1 = __importDefault(require("prop-types"));
const utils_1 = require("../../utils/utils");
const tooltip_1 = __importDefault(require("../tooltip/tooltip"));
const typography_1 = __importDefault(require("../typography/typography"));
require("../../styles/components/user-avatar.less");
const AvatarLoader = ({ size }) => (react_1.default.createElement("div", { className: "avatar-loader" },
    react_1.default.createElement(CircularProgress_1.default, { size: 0.4 * size, color: "primary" })));
const Gravatar = ({ src, borderColor }) => (src && (react_1.default.createElement("div", { className: "image-wrapper" },
    react_1.default.createElement("img", { src: src, alt: "", className: "gravatar-image", style: borderColor ? { borderColor } : {} }))));
exports.Gravatar = Gravatar;
const BaseAvatar = ({ name, classes, children }) => (react_1.default.createElement("div", { className: (0, classnames_1.default)('account-gravatar-container', classes) },
    react_1.default.createElement("div", { className: "gravatar-wrapper text-center" },
        children,
        react_1.default.createElement("div", { className: "name-initials" }, name))));
exports.BaseAvatar = BaseAvatar;
// eslint-disable-next-line react/jsx-no-useless-fragment
const AvatarComponentWrapper = ({ isForceOneLineAvatar, showFullName, children }) => (!(isForceOneLineAvatar || showFullName) ? react_1.default.createElement(react_1.default.Fragment, null, children) : react_1.default.createElement("div", { className: (0, classnames_1.default)('user-avatar', { 'avatar-container': isForceOneLineAvatar }) }, children));
const AvatarComp = ({ email, fullName, imgUrl, isContact, avatarId, size, isSavingAvatar, tooltipText, showFullName, username, tooltipClasses, showTooltip, fullNameTypographyVariant, isForceOneLineAvatar = false }) => {
    const src = imgUrl || (avatarId ? (0, utils_1.uploadcareUrl)(avatarId, size) : `${(0, utils_1.gravatarUrl)(email || username, size)}`);
    const tooltipMessage = showTooltip ? (tooltipText || fullName || email) : null;
    return (react_1.default.createElement(tooltip_1.default, { text: tooltipMessage, className: tooltipClasses },
        react_1.default.createElement("span", null,
            react_1.default.createElement(AvatarComponentWrapper, { isForceOneLineAvatar: isForceOneLineAvatar, showFullName: showFullName && !!fullName },
                react_1.default.createElement(exports.BaseAvatar, { classes: isContact ? 'contact' : '', name: fullName && !avatarId ? (0, utils_1.getInitials)(fullName) : '' }, isSavingAvatar
                    ? react_1.default.createElement(AvatarLoader, { size: size })
                    : src && react_1.default.createElement(exports.Gravatar, { src: src, borderColor: null })),
                showFullName && fullName && (react_1.default.createElement(typography_1.default, { variant: fullNameTypographyVariant, className: "avatar-fullname" }, fullName))))));
};
exports.AvatarComp = AvatarComp;
// !!!!! MUST PASS HERE THE USER MAP AS PROPD in tha past we call here as: const usersMap = useSelector((state) => get(state, 'users.usersMap', {}), shallowEqual);!!!
const UserAvatar = (props) => {
    const { email, fullName, size, avatarId, imgUrl, showTooltip, tooltipClasses, username, tooltipText, isContact, showFullName, isSavingAvatar, isForceOneLineAvatar, fullNameTypographyVariant, usersMap, } = props;
    const fullUser = (0, react_1.useMemo)(() => (email ? usersMap[email.toLowerCase()] || {} : {}), [email, usersMap]);
    return (react_1.default.createElement(AvatarComp, { showTooltip: showTooltip, tooltipClasses: tooltipClasses, username: username, showFullName: showFullName, tooltipText: tooltipText, isSavingAvatar: isSavingAvatar, size: size, isContact: isContact, imgUrl: imgUrl, email: email, isForceOneLineAvatar: isForceOneLineAvatar, avatarId: avatarId || fullUser.avatarId, fullName: fullName || fullUser.fullName || email, fullNameTypographyVariant: fullNameTypographyVariant }));
};
exports.default = UserAvatar;
// !!!!! MUST PASS HERE THE poolsList in tha past we call here as: const poolsList = useSelector((state) => state?.userPools?.data, shallowEqual);!!!
const PoolComp = ({ poolId, fullName: initFullName, showFullName, poolsList }) => {
    // const poolsList = useSelector((state) => state?.userPools?.data, shallowEqual);
    const fullName = (0, react_1.useMemo)(() => initFullName || (0, get_1.default)(poolsList.find(({ id }) => id === poolId), 'name'), [initFullName, poolId, poolsList]);
    return (react_1.default.createElement(AvatarComponentWrapper, { showFullName: showFullName && !!fullName },
        react_1.default.createElement("i", { className: "material-icons pool-icon" }, "group"),
        showFullName && fullName && (react_1.default.createElement(typography_1.default, { variant: "overline", className: "avatar-fullname" }, fullName))));
};
exports.PoolComp = PoolComp;
PoolComp.defaultProps = {
    fullName: undefined,
    showFullName: false,
};
PoolComp.propTypes = {
    poolId: prop_types_1.default.number.isRequired,
    fullName: prop_types_1.default.string,
    showFullName: prop_types_1.default.bool,
    poolsList: prop_types_1.default.array.isRequired,
};
UserAvatar.defaultProps = {
    size: undefined,
    fullName: '',
    email: '',
    username: '',
    avatarId: '',
    showTooltip: false,
    tooltipClasses: {},
    tooltipText: undefined,
    isContact: false,
    showFullName: false,
    isSavingAvatar: false,
    isForceOneLineAvatar: false,
    fullNameTypographyVariant: 'overline',
};
UserAvatar.propTypes = {
    size: prop_types_1.default.number,
    fullName: prop_types_1.default.string,
    email: prop_types_1.default.string,
    username: prop_types_1.default.string,
    avatarId: prop_types_1.default.string,
    showTooltip: prop_types_1.default.bool,
    tooltipClasses: prop_types_1.default.object,
    tooltipText: tooltip_1.default.propTypes.text,
    isContact: prop_types_1.default.bool,
    showFullName: prop_types_1.default.bool,
    isSavingAvatar: prop_types_1.default.bool,
    isForceOneLineAvatar: prop_types_1.default.bool,
    fullNameTypographyVariant: prop_types_1.default.string,
    usersMap: prop_types_1.default.object.isRequired,
};
//# sourceMappingURL=user-avatar.js.map